/**
 * GA4 web stream ID for the panel. Unset in local dev, so nothing loads.
 * Kept in its own module: `consent.ts` reads it during store setup, and importing
 * it from `google-analytics.tsx` would close an import cycle through the store.
 */
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;
